import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnmeteredParkinginline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M27 52H5V40.613C5 37.538 6.666 36 9.999 36H42c3.334 0 5 1.538 5 4.613V52H27z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13 46a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm26 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9 36c.642-1.407 1.642-3.74 3-7 2.037-4.89 2.5-6 7-6h14c4.5 0 4.963 1.11 7 6 1.358 3.26 2.358 5.593 3 7",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 52v6m30-6v6",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				x: 44,
				y: 5,
				width: 16,
				height: 15,
				rx: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52.52 9c1.41 0 2.48.923 2.48 2.408 0 1.453-1.07 2.462-2.48 2.462h-.853l.006 2.13H50V9h2.52zm.01 1.59h-.857v1.645h.856c.467 0 .769-.329.769-.827 0-.488-.302-.817-.769-.817z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M52 20v38",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgUnmeteredParkinginline;
